/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatGenerationKnowledgeBaseFile } from './SingleTurnChatGenerationKnowledgeBaseFile';
import {
  SingleTurnChatGenerationKnowledgeBaseFileFromJSON,
  SingleTurnChatGenerationKnowledgeBaseFileFromJSONTyped,
  SingleTurnChatGenerationKnowledgeBaseFileToJSON,
} from './SingleTurnChatGenerationKnowledgeBaseFile';

/**
 *
 * @export
 * @interface SingleTurnChatGenerationKnowledgeBase
 */
export interface SingleTurnChatGenerationKnowledgeBase {
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatGenerationKnowledgeBase
   */
  readonly id: number;
  /**
   *
   * @type {Array<SingleTurnChatGenerationKnowledgeBaseFile>}
   * @memberof SingleTurnChatGenerationKnowledgeBase
   */
  readonly files: Array<SingleTurnChatGenerationKnowledgeBaseFile>;
}

/**
 * Check if a given object implements the SingleTurnChatGenerationKnowledgeBase interface.
 */
export function instanceOfSingleTurnChatGenerationKnowledgeBase(
  value: object,
): value is SingleTurnChatGenerationKnowledgeBase {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('files' in value) || value['files'] === undefined) return false;
  return true;
}

export function SingleTurnChatGenerationKnowledgeBaseFromJSON(json: any): SingleTurnChatGenerationKnowledgeBase {
  return SingleTurnChatGenerationKnowledgeBaseFromJSONTyped(json, false);
}

export function SingleTurnChatGenerationKnowledgeBaseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatGenerationKnowledgeBase {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    files: (json['files'] as Array<any>).map(SingleTurnChatGenerationKnowledgeBaseFileFromJSON),
  };
}

export function SingleTurnChatGenerationKnowledgeBaseToJSON(
  value?: Omit<SingleTurnChatGenerationKnowledgeBase, 'id' | 'files'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
